<h1 mat-dialog-title>{{ 'components.dialogAppUpdate.title' | transloco }}</h1>
<div mat-dialog-content>
  {{ 'components.dialogAppUpdate.message' | transloco }}
</div>
<div mat-dialog-actions>
  <button mat-flat-button data-testid="updateApp" color="primary" (click)="update()" mat-dialog-close>
    {{ 'components.dialogAppUpdate.updateButton' | transloco }}
  </button>
</div>
